import actionTypes from '../constants/action-types';

const registerItemsGroup = (group) => ({
  type: actionTypes.REGISTER_ITEMS_GROUP,
  payload: { group },
});

export default registerItemsGroup;
